import React, { useEffect, useState } from 'react';
import { updateClassBookSettings, getClassBookingWaiverSettings } from "../../services/classApiServices";
import { useAnalytics } from '../../hooks/useAnalytics';

function ClassBookingSettings(props) {
      const { trackButtonClick } = useAnalytics();
    const [apiError, setApiError] = useState(false);
    const [digitalWaiverchecked, setDigitalWaiverChecked] = useState(false);


    const handleCheckboxChange = (e) => {
        setDigitalWaiverChecked(e.target.checked);
    };


    function classBookingSettingsShow() {
        props.toggleShow();
    }

    const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;


    async function onSaveButton() {
        const updates = {
            gymid: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
            checkboxcontent: digitalWaiverchecked,

        };
        try {
            const saverep = await updateClassBookSettings(localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "", updates);
            if (saverep === "false") {
                setApiError(true)
            } else {
                const recinfo = await saverep.json();
                console.log(recinfo);
                 await trackButtonClick("ClassBookingSetting", "Update_Class_Booking_Setting", "staff", {});
                if (props.onSettingsUpdate) {
                    props.onSettingsUpdate();
                }
                props.showAlert("Class Business Settings updated successfully.");
                props.toggleShow();
            }
        } catch (error) {
            console.error("Error updating waiver settings:", error);
        }
    }


    const fetchWaiverSettings = async () => {
        try {
            const response = await getClassBookingWaiverSettings(gymId);
            if (!response || response === "false") {
                return;
            }

            const result = await response.json();
            console.log("result", result);
            setDigitalWaiverChecked(result.iswaiver);
        } catch (error) {
            console.error("Error fetching Terms and Conditions:", error);
        }
    };


    useEffect(() => {
        fetchWaiverSettings();
    }, [gymId])

    return (
        <>
            <div>
                <div className='d-flex justify-content-between align-items-center'>
                    <label><strong>Digital Waiver Settings</strong></label>
                    <label className="switch">
                        <input className="form-control" type="checkbox" checked={digitalWaiverchecked}
                            onChange={handleCheckboxChange} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <label className="mb-0 switchlabel"> Select this option to make completing the digital waiver mandatory before members can book a class </label>

                </div>
                {apiError && <p style={{ color: 'red' }}>Something went wrong while saving settings.</p>}
            </div>
            <div class="modal-footer pb-0">
                <button class="ripple ripple-surface btn btn-secondary"
                    onClick={classBookingSettingsShow}
                >
                    Cancel
                </button>
                <button class="ripple ripple-surface btn btn-primary"
                    onClick={onSaveButton}
                >
                    Save
                </button>
            </div>
        </>
    );
}

export default ClassBookingSettings;
